import RestClient from './RestClient';
import { Release } from '../models';

class Releases extends RestClient {
    constructor() {
        super({
            // rest config
            model: Release,
            entryPoint: 'releases',
            //sortBy: 'date',
            id_field: '_id',
            // redux config
            resource: 'release',
            resources: 'releases',
        });
    }

    reorderChanges(releaseId: string, changeIds: string[]) {
        return this.PUT(`/${this.entryPoint}/${releaseId}/changes/order`, { changes: changeIds })
            .then(async response => {
                const json = await response.json().catch(() => ({}));
                if (!response.ok) {
                    throw new Error(json.err || json.error || response.statusText || 'Reorder failed');
                }
                if (json[this.resource]) {
                    json[this.resource] = new Release(json[this.resource]);
                    return json;
                }
                throw new Error(json.err || json.error || 'Reorder failed');
            });
    }
}

const ReleasesApi = new Releases();
export default ReleasesApi;
